import React, { Component } from 'react';
import './styles.css';

class Lightbox extends Component {

    constructor(props) {
        super(props);

        this.hideLightbox = this.hideLightbox.bind(this);
        this.changeImage = this.changeImage.bind(this);

        this.state = {
            visible: false,
            index: this.props.index,
            out: '',
        }
    }

    openLightbox() {
        this.setState({
            visible: true,
            index: this.props.index
        })
    }

    hideLightbox() {
        this.setState({
            visible: false,
            index: 0,
        })
    }

    changeImage(direction) {

        let newIndex = 0;

        if (direction === 'next') {
            if (this.state.index < this.props.images.length-1) {
                newIndex = this.state.index + 1;
            } else {
                newIndex = 0;
            }
        } else {
            if (this.state.index > 0) {
                newIndex = this.state.index - 1;
            } else {
                newIndex = this.props.images.length-1;
            }
        }

        let app = this;

        this.setState({
            out: 'out-' + direction
        });

        setTimeout(() => {
            app.setState({
                index: newIndex,
                out: 'in-' + direction
            });
        }, 200);

        setTimeout(() => {
            app.setState({
                out: ''
            });
        }, 300);
    }

    keydown(e) {
        if (e.keyCode === 39) {
            this.changeImage('next');
        }
        if (e.keyCode === 37) {
            this.changeImage('prev');
        }
        if (e.keyCode === 27) {
            this.hideLightbox();
        }
    }

    componentDidMount() {
        if (this.props.images[this.state.index] === undefined) {
            this.setState({
                index: 0
            });
        }
        document.addEventListener("keydown", this.keydown.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.keydown.bind(this));
    }

    render() {
        if (this.props.images.length > 0) {
            return (
                <div className={'Lightbox ' + (this.state.visible ? 'show' : '')}>
                    <div className="Lightbox-Close" onClick={this.hideLightbox}><i className="im im-x-mark-circle"></i></div>
                    <div className={'Lightbox-Content ' + this.props.className}>
                        <div
                            className={"Lightbox-Image-Holder Lightbox-Image-Holder-next Lightbox-Image-Holder-" + this.state.out }
                            style={{backgroundImage: 'url(' + (this.props.images[this.state.index].displayUrl) + ')'}}
                        >

                            <div className="Lightbox-Pref" onClick={() => this.changeImage('prev')}><i className="im im-angle-left-circle"></i></div>
                            <div className="Lightbox-Next" onClick={() => this.changeImage('next')}><i className="im im-angle-right-circle"></i></div>
                            <div className="Lightbox-Caption">{this.props.captions}</div>
                        </div>
                    </div>
                    <div className="Lightbox-Overlay" onClick={this.hideLightbox}></div>
                </div>
            );
        } else {
            return (
                <React.Fragment></React.Fragment>
            )
        }
    }
}

export default Lightbox;
